import React from "react";
import RenderSource from "./RenderSource";
import SessionRenderer from "./sessionRenderer";

export const getCellRenderer = (dataKey, column, rowData, cellData) => {
  switch (dataKey) {
    case "SessionId":
      return <SessionRenderer column={column} rowData={rowData} />;
    default:
      return <RenderSource data={cellData} dataKey={dataKey} />;
  }
};
